import React from 'react';

import Icon from '@/components/Icon/Icon';

const AboutDeviceIcon = (props) => {
    return (
        <Icon width='64' height='64' fill='none' {...props}>
            <path
                d='M17 10.2369C17 9.00148 18.0015 8 19.2369 8H35.5392C36.7746 8 37.7761 9.00148 37.7761 10.2369V53.2965C37.7761 54.5319 36.7746 55.5333 35.5392 55.5333H19.2369C18.0015 55.5333 17 54.5319 17 53.2965V10.2369Z'
                fill='#393E44'
            />
            <path
                d='M40.8008 13.7257C40.8008 13.4169 41.0512 13.1665 41.36 13.1665H46.4416C46.7504 13.1665 47.0008 13.4169 47.0008 13.7257V48.8437L46.524 55.017C46.5015 55.3083 46.2586 55.5332 45.9664 55.5332H41.8351C41.543 55.5332 41.3001 55.3083 41.2776 55.017L40.8008 48.8437V13.7257Z'
                fill='#393E44'
            />
            <path
                d='M41.834 26.5999C41.834 25.4585 42.7593 24.5332 43.9007 24.5332C45.042 24.5332 45.9673 25.4585 45.9673 26.5999V28.6665C45.9673 29.8079 45.042 30.7332 43.9007 30.7332C42.7593 30.7332 41.834 29.8079 41.834 28.6665V26.5999Z'
                fill='#00D1D2'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M43.9004 25.6001C44.4527 25.6001 44.9004 26.0478 44.9004 26.6001V28.6668C44.9004 29.219 44.4527 29.6668 43.9004 29.6668C43.3481 29.6668 42.9004 29.219 42.9004 28.6668V26.6001C42.9004 26.0478 43.3481 25.6001 43.9004 25.6001Z'
                fill='#FFFDFB'
            />
            <path
                d='M37.7673 10.0464H22.6764C21.9533 10.0464 21.3672 10.6325 21.3672 11.3556V52.1783C21.3672 52.9014 21.9533 53.4876 22.6764 53.4876H37.7673C37.7726 53.4246 37.7753 53.3608 37.7753 53.2965V51.9876H22.8672V11.5464H37.7753V10.2369C37.7753 10.1727 37.7726 10.1092 37.7673 10.0464Z'
                fill='#FFFDFB'
            />
        </Icon>
    );
};

export default AboutDeviceIcon;
